module.exports = __webpack_public_path__ + "static/chunks/src/page-ottawa/part-replacement-process/assets/image-promo.daa41c3a7f7ed157edbc969ce5e465d8.webp";